var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row pt-2 mb-1" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          {
            staticClass:
              "card ob1-push ob1-push-zigzag ob1-push-zigzag-odd ob1-push-shadow-right",
          },
          [
            _c("div", { staticClass: "card-item" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("img", {
                  staticClass: "card-img-top",
                  attrs: {
                    src: _vm.zoneReassurance.image.src,
                    alt: _vm.zoneReassurance.image.alt,
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-item" }, [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "h3",
                  {
                    staticClass: "h3 card-title",
                    attrs: { "data-clamp": "2" },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.zoneReassurance.title) +
                        "\n                            "
                    ),
                    _c("span", { staticClass: "orange-on" }, [_vm._v("on")]),
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.zoneReassurance.text) +
                      "\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "py-0 card-btn" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: {
                        href: _vm.zoneReassurance.urlButton,
                        "data-oevent-category": _vm.zoneReassurance.tms.tagZone,
                        "data-oevent-action": _vm.zoneReassurance.tms.tagName,
                        "data-oevent-label": _vm.zoneReassurance.urlButton,
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.zoneReassurance.labelButton) +
                          "\n                                "
                      ),
                      _c("span", { staticClass: "orange-on" }, [_vm._v("on")]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }